import { FC } from 'react';

interface CaseAvatarProps {
  name?: string;
  size?: number;
  unassigned?: boolean;
}

const UNASSIGNED_BG = 'var(--color-fletchers-gray-110)';
const UNASSIGNED_GLYPH = 'var(--color-fletchers-gray-200)';
const ASSIGNED_BG = 'var(--color-fletchers-green-50)';
const ASSIGNED_GLYPH = 'var(--color-fletchers-green-600)';

// Briefcase icon from Header.tsx - scaled for avatar use
const BriefcaseIcon: FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M3 13h18" />
  </svg>
);

export const CaseAvatar: FC<CaseAvatarProps> = ({ size = 32, unassigned = false }) => {
  const backgroundColor = unassigned ? UNASSIGNED_BG : ASSIGNED_BG;
  const iconColor = unassigned ? UNASSIGNED_GLYPH : ASSIGNED_GLYPH;

  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-full"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor,
      }}
    >
      <BriefcaseIcon
        style={{
          color: iconColor,
          width: `${size * 0.6}px`,
          height: `${size * 0.6}px`,
        }}
      />
    </div>
  );
};
